export const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textContainer: {
    marginRight: "8px",
    maxWidth: "80%",
  },
  progress: {
    color: "events.whiteTertiary",
  },
};
